import { render, staticRenderFns } from "./undoneTasks.vue?vue&type=template&id=6a242148"
import script from "./undoneTasks.vue?vue&type=script&lang=js"
export * from "./undoneTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports